export class OrganizationInviteExpiredError extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, OrganizationInviteExpiredError.prototype)
  }
}
